var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.icon)?_c('div',{staticClass:"overflow-hidden rounded-full"},[_c('img',{staticClass:"rounded-full",staticStyle:{"transform":"scale(1.1)"},attrs:{"src":_vm.icon.path,"alt":_vm.icon.alt}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }